<template>
  <div class="wrapper-member">
    <div class="member-info">
      <div class="member-info-top">
        <div class="id-card-pic">
          <el-image
            style="
              width: 100px;
              border-radius: 8px;
              height: 100px;
              margin-right: 10px;
            "
            :src="member.identityFrontImageUrl"
            :preview-src-list="[member.identityFrontImageUrl]"
          >
            <div
              style="
                background: #f5f7fa;
                width: 100px;
                height: 100px;
                line-height: 100px;
                text-align: center;
                color: #c0c4cc;
              "
              slot="error"
            >
              暂无图片
            </div>
          </el-image>
          <el-image
            style="width: 100px; border-radius: 8px; height: 100px"
            :src="member.identityBackImageUrl"
            :preview-src-list="[member.identityBackImageUrl]"
          >
            <div
              style="
                background: #f5f7fa;
                width: 100px;
                height: 100px;
                line-height: 100px;
                text-align: center;
                color: #c0c4cc;
              "
              slot="error"
            >
              暂无图片
            </div>
          </el-image>
        </div>

        <div class="person-info">
          <el-row :gutter="24">
            <el-col :span="14">
              <div>
                <div class="jc-info">
                  <span class="name fw700">{{ member ? member.memberName : '' }}</span>
                  <div class="tag">
                    <el-tag type="primary" effect="plain">年龄：{{ member ? member.age : '' }}</el-tag>
                    <el-tag type="primary" effect="plain">性别：{{ member ? member.genderName : '' }}</el-tag>
                  </div>
                </div>
                <span v-for="(item, i) in detailInfo.rosterLevelList" :key="i">
                  <span class="tag-ku black" v-if="item == 2" style="margin: 2px">黑名单</span>
                  <span class="tag-ku white" v-if="item == 1" style="margin: 2px">白名单</span>
                </span>
              </div>

              <div>
                <span class="mr50">
                  <span class="label">手机号：</span>
                  <span class="fw700">{{ member ? member.mobile : '' }}</span>
                  <el-button
                    type="text"
                    icon="el-icon-copy-document"
                    style="margin-left: 10px;"
                    @click="copy"
                  />
                </span>
                <span>
                <span class="label">身份证号：</span>
                <span class="fw700">{{ member ? member.identityNo : '' }}</span>
              </span>
              </div>

              <div>
                <span>
                  <span class="label">户籍地：</span>
                  <span class="fw700">{{ member ? member.identityAddress : '' }}</span>
                </span>
              </div>
            </el-col>

            <el-col :span="10">
              <div class="person-stat">
                <div class="hit-grade" v-if="!!detailInfo.store">
                  <span class="label">审核评级</span>
                  <TagLv class="tag" :name="scoreProfileData.sysHitGrade || ''" />
                  <TagLv class="tag" :name="scoreProfileData.finalHitGrade || ''" />
                  <el-button
                    style="margin-left: 5px"
                    type="text"
                    size="small"
                    icon="el-icon-edit"
                    :disabled="!isShowBtn(AUTH_BTN.review_list_detail_edit_final_grade)"
                    @click="updateFinalGrade"
                  >
                    修改
                  </el-button>
                </div>

                <div class="order-stat">
                  <span>申请量：{{ member ? member.applyOrderNum : '' }}</span>
                  <span>成单量：{{ member ? member.dealOrderNum : '' }}</span>
                  <span>结单量：{{ member ? member.fullPayOrderNum : '' }}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="supplement-info">
        <div class="supplement-header">
          <div class="section-title">
            <i class="el-icon-document"></i>
            <span>补充资料</span>
          </div>
          <el-button
            class="edit-btn"
            type="primary"
            size="mini"
            @click="onMemberProfileClick"
          >
            编辑
          </el-button>
        </div>

        <div class="special-card">
          <el-row>
            <el-col
              v-for="(item, index) in personInfoList"
              :key="index"
              :span="item.span ? item.span : 6"
            >
              <span class="label">{{ item.label }}</span>
              <span class="value">
                {{ orderMemberProfile[item.prop] === 'N' ? '否' : (orderMemberProfile[item.prop] === 'Y' ? '是'
                  : (orderMemberProfile[item.prop] || '')) }}
              </span>
            </el-col>
          </el-row>
        </div>
      </div>

      <el-dialog
        title="修改评级"
        :visible.sync="updateFinalGradeDialog"
        width="500px"
        class="update-final-grade-dialog"
      >
        <el-form ref="updateFinalGradeForm">
          <el-radio-group v-model="finalGradeData.grade">
            <el-radio
              @click.native.prevent="clickFinalGrade(item)"
              v-for="item in gradeList"
              :key="item.value"
              :label="item.value"
            >
              {{ item.name }}
            </el-radio>
          </el-radio-group>
          <el-form-item
            label="备注："
            :rules="[{ required: true, message: '该项不能为空', trigger: 'blur' }]"
          >
            <div class="final-grade-remark">
              <el-input
                style="width: 100%"
                v-model="finalGradeData.remark"
                :rows="4"
                type="textarea"
                placeholder="请输入"
              />
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="updateFinalGradeDialog = false" size="small">取 消</el-button>
          <el-button type="primary" @click="saveFinalGrade" size="small">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="补充资料"
        :visible.sync="supplyInfoDialog"
        width="800px"
        class="update-final-grade-dialog"
      >
        <el-row>
          <el-form
            :model="orderMemberProfileData"
            ref="orderMemberProfileData"
            label-width="130px"
            class="demo-ruleForm"
          >
            <el-col
              v-for="(item, index) in personInfoList"
              :key="index"
              :span="12"
            >
              <el-form-item
                :label="item.label"
                :prop="item.prop"
                :rules="item.rules || []"
              >
                <el-select
                    v-if="item.prop === 'overdueStatus'"
                    v-model="orderMemberProfileData[item.prop]"
                    placeholder="请选择"
                    size="mini"
                >
                  <el-option label="否" value="N" />
                  <el-option label="是" value="Y" />
                </el-select>
                <el-input
                    v-else
                    v-model="orderMemberProfileData[item.prop]"
                    :type="item.inputType || 'text'"
                    size="mini"
                    placeholder="请输入"
                />
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <div slot="footer">
          <el-button @click="supplyInfoDialog = false" size="small">取 消</el-button>
          <el-button type="primary" @click="saveProfile" size="small">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  updateFinalHitGradeAPI,
  saveOrderMemberProfileAPI,
} from "./api";
import { authBtnMixin } from "@/mixins/authBtnMixin";
import { getDictEnumListAPI } from "@/enum/dict";

export default {
  mixins: [authBtnMixin],
  name: "BaseInfo",
  inject: ["reload"],

  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },

    flag: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      orderMemberProfileData: {
        orderNo: "",
        memberId: "",
        zmScore: "",
        overdueStatus: "",
        workCompany: "",
        income: "",
      },
      scoreProfileData: {
        orderNo: "",
        sysHitGrade: "",
        finalHitGrade: "",
      },
      personInfoList: [
        {
          prop: "zmScore",
          label: "芝麻分：",
          inputType: "number",
          span: 5,
          rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }]
        },
        {
          prop: "overdueStatus",
          label: "是否逾期：",
          span: 5,
        },
        {
          prop: "workCompany",
          label: "工作单位：",
          span: 9,
        },
        {
          prop: "income",
          label: "薪资：",
          span: 5,
          rules: [{ validator: function(rule, value, callback) {
            if (value && value !== '' && /^(0|[1-9]\d*)(\.\d{1,2})?$/.test(value) == false) {
              callback(new Error("请输入正确的薪资"));
            } else {
              callback();
            }
          }, trigger: 'blur' }]
        },
      ],
      gradeList: [],
      finalGradeData: {
        grade: "",
        remark: "",
      },
      supplyInfoDialog: false,
      updateFinalGradeDialog: false,
    };
  },

  computed: {
    member() {
      let mem = {};
      if (this.detailInfo.member) {
        mem = this.detailInfo.member;
      }
      return mem;
    },

    orderMemberProfile() {
      return this.detailInfo.orderMemberProfile || {};
    },

    orderScoreProfile() {
      return this.detailInfo.orderScoreProfile || {};
    },
  },

  watch: {
    orderMemberProfile(val) {
      if (val && this.flag) {
        this.orderMemberProfileData = { ...this.orderMemberProfile, ...val };
      }
    },

    orderScoreProfile(val) {
      if (val && this.flag) {
        this.scoreProfileData = { ...this.orderScoreProfile, ...val };
      }
    },
  },

  methods: {
    copy() {
      navigator.clipboard.writeText(`${this.member.memberName} ${this.member.mobile}`);
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },

    onMemberProfileClick() {
      this.supplyInfoDialog = true;
    },

    // 保存补充信息
    saveProfile() {
      this.$refs.orderMemberProfileData.validate((valid) => {
        if (valid) {
          this.orderMemberProfileData.orderNo = this.detailInfo.orderNo;
          this.orderMemberProfileData.memberId = this.detailInfo.member.id;
          saveOrderMemberProfileAPI(this.orderMemberProfileData).then(() => {
            this.$message.success("保存成功");
            this.supplyInfoDialog = false;
            this.$emit("update:flag", true);
            this.$emit("updateDetail");
          });
        }
      });
    },

    clickFinalGrade(item) {
      this.finalGradeData.grade = item.value;
    },

    updateFinalGrade() {
      getDictEnumListAPI("member:grade").then((res) => {
        this.gradeList = res;
        this.finalGradeData.grade = this.detailInfo.orderScoreProfile.finalHitGrade;
        this.finalGradeData.remark = '';
        this.updateFinalGradeDialog = true;
      });
    },

    saveFinalGrade() {
      let param = {
        orderNo: this.detailInfo.orderScoreProfile.orderNo,
        grade: this.finalGradeData.grade,
        remark: this.finalGradeData.remark,
      };
      updateFinalHitGradeAPI(param).then(() => {
        this.$message.success("保存成功");
        this.updateFinalGradeDialog = false;
        this.$emit("update:flag", true);
        this.$emit("update:updatePeriod", false);
        this.$emit("updateDetail");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.without-layout .wrapper-member {
  padding: 0 !important;
}

.wrapper-member {
  width: 100%;
}

.member-info ::v-deep {
  border-color: transparent;
  border-radius: 16px;
  color: #222222;

  .fw700 {
    font-weight: 700;
  }

  .label {
    color: #606266;
    font-size: 14px;
  }
  
  .el-button--text {
    color: #409EFF;
    padding: 0;
    transition: all 0.3s ease;
    
    &:hover {
      color: #66b1ff;
    }
  }

  .member-info-top {
    display: flex;
    align-items: flex-start;
    padding: 0;

    .id-card-pic {
      margin-right: 24px;
      
      .el-image {
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
      }
    }

    .person-info {
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: column;
      line-height: 32px;

      .mr50 {
        margin-right: 50px;
      }

      .el-tag {
        height: 26px;
        border-radius: 13px;
        margin-right: 8px;
        line-height: 26px;
        padding: 0 12px;
        font-size: 12px;
        border: none;
      }

      .jc-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 16px;
        margin-bottom: 12px;

        .name {
          color: #303133;
          font-size: 22px;
          font-weight: 700;
          font-family: 微软雅黑;
        }
        
        .tag {
          display: flex;
          gap: 8px;
        }
      }

      .person-stat {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #303133;
        gap: 12px;
        padding: 16px;
        background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
        border-radius: 10px;
        border: 1px solid #e4e7ed;

        .hit-grade {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;

          .label {
            font-size: 14px;
            font-weight: 600;
            margin-right: 12px;
            color: #303133;
          }

          .tag {
            margin: 0 4px;
          }
        }

        .order-stat {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          gap: 16px;

          span {
            font-size: 13px;
            color: #606266;
            padding: 4px 12px;
            background: #ffffff;
            border-radius: 6px;
            border: 1px solid #e4e7ed;
          }
        }
      }
    }
  }

  .update-final-grade-dialog {
    ::v-deep .el-dialog {
      border-radius: 12px;
      
      .el-dialog__header {
        padding: 20px 24px;
        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
        border-bottom: 2px solid #f0f2f5;
        
        .el-dialog__title {
          font-size: 18px;
          font-weight: 700;
          color: #1a1e25;
        }
      }
      
      .el-dialog__body {
        padding: 24px;
      }
      
      .el-dialog__footer {
        padding: 16px 24px;
        background: #fafbfc;
        border-top: 1px solid #f0f2f5;
      }
    }

    .el-radio-group {
      display: flex;
      justify-content: space-around;
      margin-bottom: 30px;
      
      ::v-deep .el-radio {
        margin-right: 0;
        
        .el-radio__label {
          padding-left: 8px;
        }
      }
    }

    .final-grade-remark {
      display: flex;
      align-items: flex-start;
      flex-wrap: nowrap;
      white-space: nowrap;
      
      ::v-deep .el-textarea__inner {
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        transition: all 0.3s ease;
        
        &:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
        }
      }
    }
  }
}

.tag-ku {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  margin-right: 8px;
  color: #fff;
  font-weight: 500;
  display: inline-block;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.black {
  background: linear-gradient(135deg, #f56c6c 0%, #d05252 100%);
}

.white {
  background: linear-gradient(135deg, #67c23a 0%, #4cd2a2 100%);
}

.supplement-info {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e4e7ed;
}

.supplement-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 18px;
    color: #409EFF;
  }
}

.edit-btn {
  cursor: pointer;
  height: 28px;
  border-radius: 14px;
  padding: 0 16px;
  font-size: 12px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
  }
}

.special-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
  line-height: 36px;
  padding: 16px 20px;
  border-radius: 10px;
  border: 1px solid #e4e7ed;

  .label {
    display: inline-block;
    min-width: 120px;
    text-align: right;
    color: #606266;
    font-weight: 500;
  }

  .value {
    font-weight: 600;
    color: #303133;
  }
}
</style>
